import { render, staticRenderFns } from "./loginBox1.vue?vue&type=template&id=1ffd3f14&scoped=true"
import script from "./loginBox1.vue?vue&type=script&lang=js"
export * from "./loginBox1.vue?vue&type=script&lang=js"
import style0 from "./loginBox1.vue?vue&type=style&index=0&id=1ffd3f14&prod&lang=scss"
import style1 from "./loginBox1.vue?vue&type=style&index=1&id=1ffd3f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd3f14",
  null
  
)

export default component.exports